import React from 'react';
import AtlasV2DropdownMetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DropdownMetricColumnChart';
import AtlasV2MetricColumnChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2MetricColumnChart';
import { HIDE_GROUP_BY_LEVEL } from 'src/components/Layout/AtlasV2PageLayout';
import { useMainEntityType } from 'src/utils/Hooks/reduxSelectors';

export const OTHER_TRAFFIC_FILED_IDS = ['[other traffic]', '[Other Traffic]'];

const AtlasV2TotalTrafficTopEntity = () => {
  const mainEntityType = useMainEntityType();

  return mainEntityType === 'product' ? (
    <AtlasV2MetricColumnChart
      fieldName="totalClicks"
      indexName="traffic"
      useAdvancedSearchDataArgs={{
        fields: [{ name: 'totalClicks' }],
        groupByField: 'searchTerm',
        addFieldsFromPrimaryResponse: true
      }}
      beaconChartWithLegendPropsBuilder={(props) => ({
        ...props,
        title: 'Total Traffic by Keyword'
      })}
      preProcessData={(data) => {
        const otherTraffics = data.filter((datum) => OTHER_TRAFFIC_FILED_IDS.includes(datum.fieldId));
        const remainingData = data.filter((datum) => !OTHER_TRAFFIC_FILED_IDS.includes(datum.fieldId));
        return [...remainingData, ...otherTraffics];
      }}
    />
  ) : (
    <AtlasV2DropdownMetricColumnChart
      fieldName="totalClicks"
      indexName="traffic"
      dropdownOptions={[
        {
          id: 'searchTerm',
          label: 'Keyword'
        },
        {
          id: 'brandId',
          label: 'Brand'
        },
        {
          id: 'categoryId',
          label: 'Category'
        },
        {
          id: 'subCategoryId',
          label: 'Subcategory'
        },

        {
          id: 'stacklineSku',
          label: 'Product'
        },
        {
          id: 'parentBrandId',
          label: 'Manufacturer'
        }
      ].filter(
        (option) =>
          !option.id.toLowerCase().startsWith(mainEntityType) &&
          HIDE_GROUP_BY_LEVEL?.[mainEntityType]?.[option.id] !== true
      )}
      useAdvancedSearchDataArgs={{
        requestBuilder: (builder, _isComparison, _fields) => {
          return builder;
        },
        addFieldsFromPrimaryResponse: true
      }}
      preProcessData={(data) => {
        const otherTraffics = data.filter((datum) => OTHER_TRAFFIC_FILED_IDS.includes(datum.fieldId));
        const remainingData = data.filter((datum) => !OTHER_TRAFFIC_FILED_IDS.includes(datum.fieldId));
        return [...remainingData, ...otherTraffics];
      }}
      titlePrefix="Total Traffic by"
    />
  );
};

export default AtlasV2TotalTrafficTopEntity;
